export default __webpack_public_path__ + "static/media/dreamscape_account_parents.43715cbe.png";